import React from 'react'
import "./SellerScreen.css"

export default function SellerScreen() {
  return (
    <div>SellerScreen</div>
  )
}
